/**
 * A sortable table header cell — wraps MUI's TableSortLabel with the
 * shared useTableSort state so the list pages (Devices, Procedures,
 * Participants) get consistent click-to-sort headers with one line each.
 */
import type { ReactNode } from 'react';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import type { SxProps, Theme } from '@mui/material/styles';

import type { TableSort } from '../util/tableSort';

export function SortHeader<K extends string>({
  label,
  col,
  sort,
  align,
  sx,
}: {
  label: ReactNode;
  col: K;
  sort: TableSort<K>;
  align?: 'left' | 'right' | 'center';
  sx?: SxProps<Theme>;
}) {
  const active = sort.orderBy === col;
  return (
    <TableCell align={align} sx={sx} sortDirection={active ? sort.order : false}>
      <TableSortLabel
        active={active}
        direction={active ? sort.order : 'asc'}
        onClick={() => sort.onSort(col)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
